import { TranslateService } from '@ngx-translate/core';

// Задача (Фаза 6): "Темите и Source Type: во базата остануваат на англиски, се преведуваат
// само при прикажување (посебни клучеви за секоја тема/тип)." The backend always returns the
// AiTaxonomy enum's English label (ClientAnalyticsServiceImpl reads Tag/EnrichedMention labels
// straight from AiTaxonomy.SourceType/IndustryTopic/CorporateTopic.getLabel()) - these maps go
// from that exact English label to the i18n key under ANALYTICS_TAXONOMY, so every screen that
// renders a topic/source-type string (chart labels, table rows, chips, dropdowns) translates it
// the same way instead of re-deriving its own mapping.

const SOURCE_TYPE_KEYS: Record<string, string> = {
	'News Story': 'ANALYTICS_TAXONOMY.SOURCE_TYPE.NEWS_STORY',
	'Press Release': 'ANALYTICS_TAXONOMY.SOURCE_TYPE.PRESS_RELEASE',
	Interview: 'ANALYTICS_TAXONOMY.SOURCE_TYPE.INTERVIEW',
	Statement: 'ANALYTICS_TAXONOMY.SOURCE_TYPE.STATEMENT',
	'Opinion / Column': 'ANALYTICS_TAXONOMY.SOURCE_TYPE.OPINION_COLUMN',
};

const INDUSTRY_TOPIC_KEYS: Record<string, string> = {
	'Market & Competition': 'ANALYTICS_TAXONOMY.INDUSTRY_TOPIC.MARKET_COMPETITION',
	'Products, Services & Pricing': 'ANALYTICS_TAXONOMY.INDUSTRY_TOPIC.PRODUCTS_SERVICES_PRICING',
	'Technology & Innovation': 'ANALYTICS_TAXONOMY.INDUSTRY_TOPIC.TECHNOLOGY_INNOVATION',
	'Regulation & Legal': 'ANALYTICS_TAXONOMY.INDUSTRY_TOPIC.REGULATION_LEGAL',
	'Infrastructure & Supply Chain': 'ANALYTICS_TAXONOMY.INDUSTRY_TOPIC.INFRASTRUCTURE_SUPPLY_CHAIN',
	'Macroeconomics & Trends': 'ANALYTICS_TAXONOMY.INDUSTRY_TOPIC.MACROECONOMICS_TRENDS',
};

const CORPORATE_TOPIC_KEYS: Record<string, string> = {
	'Corporate Governance & Finance': 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.CORPORATE_GOVERNANCE_FINANCE',
	'Customer Experience & Support': 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.CUSTOMER_EXPERIENCE_SUPPORT',
	'CSR & Sustainability': 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.CSR_SUSTAINABILITY',
	'Sponsorships & PR Events': 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.SPONSORSHIPS_PR_EVENTS',
	'Crisis, Legal & Issues': 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.CRISIS_LEGAL_ISSUES',
	'HR & Workforce': 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.HR_WORKFORCE',
	Other: 'ANALYTICS_TAXONOMY.CORPORATE_TOPIC.OTHER',
};

export function translateSourceType(label: string | null | undefined, translate: TranslateService): string {
	if (!label) return '';
	const key = SOURCE_TYPE_KEYS[label];
	return key ? translate.instant(key) : label;
}

// Tries Industry first, then Corporate - most call sites (Topics' combined list, Overview's
// story-modal chips, Media/Sentiment's topic references) pool both groups into one list/string
// without tracking which group a given label came from, so one function covers both maps rather
// than forcing every caller to know the group up front. Falls back to the raw English label for
// a value that matches neither fixed list (should not happen for AiTaxonomy-sourced data, but
// never silently blank a real value).
export function translateTopic(label: string | null | undefined, translate: TranslateService): string {
	if (!label) return '';
	const key = INDUSTRY_TOPIC_KEYS[label] || CORPORATE_TOPIC_KEYS[label];
	return key ? translate.instant(key) : label;
}
